import { render, staticRenderFns } from "./ServiceSubcategoriesForm.vue?vue&type=template&id=2f33036a"
import script from "./ServiceSubcategoriesForm.vue?vue&type=script&lang=js"
export * from "./ServiceSubcategoriesForm.vue?vue&type=script&lang=js"
import style0 from "./ServiceSubcategoriesForm.vue?vue&type=style&index=0&id=2f33036a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports